import ExtLink from 'components/common/ExtLink'
import IntLink from 'components/common/IntLink'
import TelegramIcon from 'components/icons/TelegramIcon'
import VkIcon from 'components/icons/VkIcon'
import FooterLogo from 'components/logos/FooterLogo'
import RatingsBadge from 'components/common/RatingsBadge'
import {
  ADDRESS,
  CONTACT_EMAIL,
  CONTACT_PHONE,
  FOOTER_ABOUT_PAGE_LIST,
  TELEGRAM_LINK,
  VK_LINK,
} from 'config/constants'
import useMenus from 'hooks/useMenus'
import { getServices } from 'lib/getServices'
import { isNonEmptyArray, isPresent } from 'lib/utils'
import Image from 'next/image'
import appStore from 'public/img/App_Store.png'
import googlePlay from 'public/img/Google_Play.png'
import RuStore from 'public/img/RuStore.png'
import img1 from 'public/img/footer1.png'
import img2 from 'public/img/footer2.png'
import img3 from 'public/img/footer3.png'
import img4 from 'public/img/footer4.png'
import img5 from 'public/img/footer5.png'

import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectCities, type IService } from 'store/api'

const FooterDsk = () => {
  const cities = useSelector(selectCities('ru'))

  let { footerMenu } = useMenus()

  const [services, setServices] = useState<IService[]>([])

  const defaultCity = useMemo(
    () => (isNonEmptyArray(cities) ? cities[0] : null),
    [cities]
  )

  useEffect(() => {
    void (async () => {
      const servicesData = await getServices('ru')

      if (isPresent(servicesData)) {
        setServices(servicesData.services)
      }
    })()
  }, [])

  // const openHours = useMemo(
  //   () =>
  //     `Ежедневно ${defaultCity?.call_time.begin || '08:00'} - ${
  //       defaultCity?.call_time.end || '20:00'
  //     }`,
  //   [defaultCity]
  // )

  // CLS-fix: не делаем early return null когда defaultCity ещё не загружен.
  // На SSR cities нет в Redux store, и старый `return null` приводил к тому,
  // что footer "вырастал" с 0 до ~800px после hydration → mobile CLS 0.434.
  // Все обращения к defaultCity внизу — через ?.X || FALLBACK, готовы к null.
  // if (isAbsent(defaultCity)) return null

  const menuComponent = (
    <div className='hidden xl:flex flex-col'>
      <IntLink
        href={`/categories`}
        className='text-sm mb-6 !leading-6 font-bold text-dark uppercase'>
        Доставка Фуршетных блюд
      </IntLink>

      {footerMenu.map(({ name, slug }) => (
        <div key={slug}>
          <IntLink
            href={`/categories/${slug}`}
            className='line-clamp-1 text-base2 !leading-7 text-mediumDark'
          >
            {name}
          </IntLink>
        </div>
      ))}
    </div>
  )

  const cateringComponent = (
    <div className='hidden sm:flex flex-col'>
      <IntLink
        href={`/catering`}
        className='text-sm mb-6 !leading-6 font-bold text-dark uppercase'>
        Кейтеринг
      </IntLink>

      {services.map(({ name, slug }) => (
        <div key={slug}>
          <IntLink
            href={`/catering/${slug}`}
            className='line-clamp-1 text-base2 !leading-7 text-mediumDark'
          >
            {name}
          </IntLink>
        </div>
      ))}
    </div>
  )

  const aboutComponent = (
    <div className='hidden sm:flex flex-col'>
      <IntLink
        href={`/about`}
        className='text-sm mb-6 !leading-6 font-bold text-dark uppercase'>
        О нас
      </IntLink>

      {FOOTER_ABOUT_PAGE_LIST.map((x) => (
        <div key={x.href}>
          <IntLink
            shallow={!x.deep}
            href={x.href}
            className='text-base2 !leading-6 text-mediumDark'
          >
            {x.name}
          </IntLink>
        </div>
      ))}
    </div>
  )

  return (
    <footer className='bg-lightGrey custom-px pt-2 pb-4 bg-spoons-footer-pattern'>
      <div className='grid grid-cols-3 xl:grid-cols-4 justify-between gap-12 lg:gap-24 pb-4 mt-8 pt-3'>
        <div className='flex-shrink-0'>
          <FooterLogo className='h-[116px] w-[178px]' />

          <div className='mt-5'>
            <a
              className='whitespace-nowrap text-mediumDark tracking-[-0.0272em;] text-xl font-bold !leading-6 '
              href={`tel:+${defaultCity?.phones[0]?.replace(/\D/g, '') ||
                CONTACT_PHONE.replace(/\D/g, '')
                }`}
            >
              {defaultCity?.phones[0] || CONTACT_PHONE}
            </a>
          </div>

          <div className='flex flex-col row-start-1 col-span-2 md:col-span-1 mt-4'>
            <div className='text-sm !leading-7 font-bold text-dark inline-flex items-center gap-2'>
              Адрес:
            </div>
            <div className='text-sm md:text-base2 !leading-6 text-mediumDark'>
              {defaultCity?.location?.address || ADDRESS}
            </div>
          </div>

          <div className='mt-4'>
            <div className='font-bold text-sm text-dark !leading-7'>
              Режим работы:
            </div>

            <div className='flex flex-row gap-2.5'>
              <div className='text-gray-700 text-xs md:text-base2 !leading-6'>
                Пн-вс
              </div>
              <div className='text-mediumDark text-xs md:text-base2 !leading-6'>
                8:00–19:00
              </div>
            </div>
          </div>

          <div className='row-start-3 col-start-1 mt-4'>
            <div className='font-bold text-sm text-dark !leading-6'>
              E-mail:{' '}
            </div>
            <a
              className='text-mediumDark text-xs md:text-base2 !leading-6 underline'
              href={`mailto:${CONTACT_EMAIL}`}
            >
              {CONTACT_EMAIL}
            </a>
          </div>
        </div>
        {menuComponent}
        {cateringComponent}
        {aboutComponent}
      </div>

      <div className='flex flex-row justify-between items-center gap-12 mt-4 border-t pt-8'>
        <div className='flex flex-row justify-around lg:justify-center items-center'>
          <RatingsBadge variant='dsk' />
        </div>

        <div className='flex flex-row justify-center items-center gap-4'>
          <Image
            src={img1}
            layout='fixed'
            objectFit='contain'
            width='54px'
            height='36px'
            alt='Сертификат 1'
          />
          <Image
            src={img2}
            layout='fixed'
            objectFit='contain'
            width='54px'
            height='38px'
            alt='Сертификат 2'
          />
          <Image
            src={img3}
            layout='fixed'
            objectFit='contain'
            width='54px'
            height='36px'
            alt='Сертификат 3'
          />
          <Image
            src={img4}
            layout='fixed'
            objectFit='contain'
            width='82px'
            height='36px'
            alt='Сертификат 4'
          />
          <Image
            src={img5}
            layout='fixed'
            objectFit='contain'
            width='68px'
            height='36px'
            alt='Сертификат 5'
          />
        </div>
      </div>

      <div className='xl:hidden my-9 mx-auto text-center text-dark text-2xs md:text-xs md:text-center'>
        {defaultCity?.footer?.footerMsg || (
          <>
            Moscow Food - это более 15 лет успешной работы в сфере
            общественного питания. Профессиональная команда в сфере
            кейтеринговых и ивент услуг и разнообразное меню. Команда
            профессиональных поваров готова предложить Вам широкий
            ассортимент блюд на любой вкус — от классической
            европейской кухни до экзотических блюд.
          </>
        )}
      </div>

      <div className='flex flex-row mt-9 justify-between gap-20 items-center'>
        <div className='w-50 flex-shrink-0 flex flex-row gap-4'>
          <div className='flex flex-row gap-2 items-center'>
            <ExtLink
              className='leading-none'
              href='https://play.google.com/store/apps/details?id=com.moscowfood'
            >
              <Image
                src={googlePlay}
                layout='fixed'
                objectFit='contain'
                width='128px'
                height='40px'
                title='Google Play'
                alt='Google Play'
              />
            </ExtLink>

            <ExtLink
              className='leading-none'
              href='https://apps.apple.com/ru/app/moscowfood/id6447418248'
            >
              <Image
                src={appStore}
                layout='fixed'
                objectFit='contain'
                width='128px'
                height='40px'
                title='App Store'
                alt='App Store'
              />
            </ExtLink>

            <ExtLink
              className='leading-none'
              href='https://www.rustore.ru/catalog/app/com.moscowfood'
            >
              <Image
                src={RuStore}
                layout='fixed'
                objectFit='contain'
                width='128px'
                height='40px'
                title='RuStore'
                alt='RuStore'
              />
            </ExtLink>
          </div>
        </div>

        <div className='hidden xl:block mx-auto text-center text-dark text-xs md:text-center'>
          {defaultCity?.footer?.footerMsg || (
            <>
              Moscow Food - это более 15 лет успешной работы в сфере
              общественного питания. Профессиональная команда в сфере
              кейтеринговых и ивент услуг и разнообразное меню.
              Команда профессиональных поваров готова предложить Вам
              широкий ассортимент блюд на любой вкус — от классической
              европейской кухни до экзотических блюд.
            </>
          )}
        </div>

        <div className='w-50 flex-shrink-0 flex justify-end flex-row items-center'>
          <span className='md:pt-0 block text-dark/70 text-xs mr-4'>
            Мы в соцсетях:
          </span>
          <div className='flex gap-2 items-center'>
            <ExtLink title='ВКонтакте' aria-label='ВКонтакте' href={VK_LINK}>
              <VkIcon className='w-8 h-8 rounded hover:text-darkYellow' />
            </ExtLink>
            <ExtLink title='Телеграм' aria-label='Телеграм' href={TELEGRAM_LINK}>
              <TelegramIcon className='w-8 h-8 rounded hover:text-darkYellow' />
            </ExtLink>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default FooterDsk
